import {createGlobalStyle} from 'styled-components'

const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
     width: 4px
     height: 4px
     background-color: rgba(128,128,128,0.5)
   }
   ::-webkit-scrollbar-thumb {
     background-color: #848e9c
   }
   ::-webkit-scrollbar-track {
     background-color: transparent
   }

  body, html, #__next {
    color: #fff;
    background: #0B0E11;

    .ReactVirtualized__Grid {
      &.ReactVirtualized__fixed-table {
        overflow: unset !important;

        .ReactVirtualized__Grid__innerScrollContainer {
          min-height: 200px;
          overflow: unset !important;
        }
      }
    }
  }
  
  input[type=range] {
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 72px;
  height: 4px;
  background: #2a2f37;
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;
  /* Hides the slider so custom styles can be added */
  background: transparent;
  border-color: transparent;
  color: transparent;
}

/* WebKit/Blink */
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: 1px solid #000000;
  width: 7px;
  height: 14px;
  background: #848E9C;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}

/* Firefox */
input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid #000000;
  width: 7px;
  height: 14px;
  background: #848E9C
  cursor: pointer;
}

/* IE */
input[type=range]::-ms-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid #000000;
  width: 7px;
  height: 14px;
  background: #848E9C
  cursor: pointer;
}
`

export default GlobalStyle
